export default "__VITE_ASSET__236384e1__"